import { ActionType } from '../../constants/ActionTypes';
import config from '../../constants/Configs';
import Utils from '../../services/Utils';
import { RestPath } from '../../constants/SitePaths';
import { Constants } from '../../constants/Constants';
import axios from 'axios';
import initialState from '../../store/InitialState';
import { Auth } from '../../services/Auth';


/* Settings SETTINGS */


export const resetStore = () => ({
    type: ActionType.RESET_STORE,
    state: initialState
})

export const getSettingsBegin = (data) => ({
    type: ActionType.GET_SETTINGS_BEGIN,
    payload: data
});

export const getSettingsAndResetLogoBegin = (data) => ({
    type: ActionType.GET_SETTINGS_AND_RESET_LOGO_BEGIN,
    payload: data
});

export const resetPopupsVisibility = () => ({
    type: ActionType.RESET_POPUPS_VISIBILITY
})

export const getSettingsError = (data) => ({
    type: ActionType.GET_SETTINGS_ERROR,
    payload: data
});

export const getSettingsSuccess = (data) => ({
    type: ActionType.GET_SETTINGS_SUCCESS,
    payload: data
});

export const getSportTokenBegin = (data) => ({
    type: ActionType.GET_SPORT_BEGIN,
    payload: data
});

export const getSportTokenError = (data) => ({
    type: ActionType.GET_SPORT_ERROR,
    payload: data
});

export const getSportTokenSuccess = (data) => ({
    type: ActionType.GET_SPORT_SUCCESS,
    payload: data
});
export const openSportBetHistory = (data) => ({
    type: ActionType.OPEN_SPORT_BET_HISTORY,
    payload: data
});

export const setDemoMode = (data) => ({
    type: ActionType.SET_DEMO_MODE,
    payload: data
})
export const setColorMode = (data) => ({
    type: ActionType.SET_COLOR_MODE,
    payload: data
})

export const setPopUpsColorMode = (data) => ({
    type: ActionType.SET_POPUPS_COLOR_MODE,
    payload: data
})

export const setCurrency = (data) => ({
    type: ActionType.SET_CURRENCY_ID,
    payload: data
})

export const getReachLimit = (data) => ({
    type: ActionType.GET_REACH_LIMIT,
    payload: data
})

export const getUnverifiedUserReminder = (data) => ({
    type: ActionType.GET_UNVERIFIED_USER_REMINDER,
    payload: data
})



/* CONTROLS SETTINGS */

const getCurrency = (settings) => {
   return dispatch => { 
        const defaultCurrency = settings.currencies.find(el => el.isDefault);
        
        dispatch(setCurrency(settings.isCurrencySymbolEnabled ?  defaultCurrency.name : defaultCurrency.id));
    }
}

export function getSettings(withLoading = true) {
    return dispatch => {

        dispatch(getSettingsBegin(withLoading));

        //If seettings are presented in the page, we will use them
        if(window.dgbSettings) {
            dispatch(getSettingsSuccess(window.dgbSettings));
            return;
        }

        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_SETTINGS}`,
        }).then((response) => {
            if(response.data && response.data.token) {
                Utils.setTokenInLocalStorage(response.data.token);
            }

            //temporary solution 
            let data = response.data;
            if(config.NEW_PLAT && (response.data.bonusSettings?.sportBonusEnabled || response.data.bonusSettings?.casinoBonusEnabled)) {
                data.hasBonusCampaign = {
                    hasCasinoBonusCampaign: response.data.bonusSettings?.casinoBonusEnabled,
                    hasSportBonusCampaign: response.data.bonusSettings?.sportBonusEnabled
                }
            }

            dispatch(getSettingsSuccess(data));

            if(!Auth.isAuthenticated()) {
                dispatch(getCurrency(data));
            }
        }).catch((error) => {
            console.log(error);
            if (error.response) {
                dispatch(getSettingsError(error.response.data));
            } else {
                dispatch(getSettingsError(error));
            }
        });
    };
}

export function getSportToken(data) {
    return dispatch => {

        dispatch(getSportTokenBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_GAME_LAUNCH + Utils.objectToQueryParams(data)
        }).then((response) => {
            dispatch(getSportTokenSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getSportTokenError(error.response.data));
                    return error.response.data;
                } else {
                    dispatch(getSportTokenError(error));
                    return error;
                }

            });
    };
}